import React, { forwardRef } from "react";

import { format } from "date-fns";

import {
  Box,
  Flex,
  Spacer,
  Text,
  HStack,
  Stack,
  Image,
} from "@chakra-ui/react";

import logomca from "../../../img-docs/logomcapn.png";

import { IrmaoTable } from "../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";

export const ComponentToPrintCriancaPendencia = forwardRef((props, ref) => {
  return (
    <Box display="block" ref={ref}>
      <table>
        <thead>
          <tr>
            <td>
              {/* Header Spacer */}
              <Box height="100px" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Box display="break-page">
                <Stack alignItems="center" p={10} mt={10}>
                  <Text fontSize={"2xl"} fontWeight={700}>
                    Pendências na Ficha da Criança/Adolescente
                  </Text>
                  <Text>{""}</Text>
                  <Text color="#169499" fontSize={"lg"} fontWeight={700}>
                    {props?.dados?.nome ?? ""} (Data de Nascimento:{" "}
                    {props?.dados?.dataNascimento
                      ? format(props?.dados?.dataNascimento, "dd/MM/yyyy") +
                        (props?.dados?.dataNascimentoEstimada === "S"
                          ? " (Estimada)"
                          : "")
                      : ""}
                    )
                  </Text>

                  <Text color="#169499" fontSize={"lg"} fontWeight={700}>
                    {props?.dados?.servicoAcolhimento?.nomeFantasia ?? ""}
                  </Text>
                  <Text>{""}</Text>
                  <Text
                    fontSize={"md"}
                    border={"solid 1px #DDEBEA"}
                    borderLeft={"solid 2px"}
                    p={2}
                    alignSelf={"start"}
                  >
                    Total de pendências:{" "}
                    {props?.dataPendencias ? props?.dataPendencias?.length : ""}
                  </Text>
                  <Box display={"block"} w={"700px"}>
                    <IrmaoTable
                      mt={"0px"}
                      columns={props.columnsPendencias}
                      data={props.dataPendencias}
                      entidade="pendencias"
                      disableHeaderOptions={true}
                      isPrint={true}
                    />
                  </Box>
                </Stack>
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              {/* Footer Spacer */}
              <Box height="150px" />
            </td>
          </tr>
        </tfoot>
      </table>

      {/* Header */}
      <HStack
        position="fixed"
        top={0}
        py={10}
        alignItems="center"
        backgroundColor="#DDEBEA"
        zIndex={100}
        width="100%"
      >
        <Box zIndex={1} ml={10}>
          <Image w={200} src={logomca} />
        </Box>
        <Box
          h={"full"}
          width={"35%"}
          backgroundColor="#006064"
          left={-2}
          position={"absolute"}
          zIndex={0}
        />
      </HStack>
      {/* Footer */}
      <Box
        position="fixed"
        bottom={10}
        pb="17.5px"
        pt="20px"
        w="100%"
        px="15px"
        backgroundColor="#006064"
        zIndex={100}
      >
        <Text color={"#fff"}>Usuário: {props?.user?.name}</Text>
        <Text color={"#fff"}>
          Orgão: {props?.dados?.nomeOrgao || props?.dados?.nomeOrgaoExterno}
        </Text>
        <Text color={"#fff"}>{`Data da impressão: ${format(
          new Date(),
          "dd/MM/yyyy"
        )} ${format(new Date(), "HH:mm:ss")}`}</Text>
      </Box>
      <Flex
        position="fixed"
        bottom={0}
        pt="10px"
        w="100%"
        px="15px"
        backgroundColor="#FFF"
        zIndex={100}
      >
        <HStack spacing="35px">
          <Text>{format(new Date(), "dd/MM/yyyy")}</Text>
          <Text>{format(new Date(), "HH:mm:ss")}</Text>
        </HStack>

        <Spacer />

        <Text id="pageForPrint">Página</Text>
      </Flex>
    </Box>
  );
});
